export default {
  // host: 'https://indicei3-api.herokuapp.com/api/',
  // host: 'http://0.0.0.0:8000/api/',
  // host: '159.89.34.175:8000/api/',
  host: 'https://indice-i3-api.herokuapp.com/api/',
  projectFullInformation: 'projectfullinformation/?format=json',
  authenticate: 'authenticate/?format=json',
  apiToken: 'api-token-auth/?format=json',
  oneProjectFullInformation: (project_id) => {return 'projectfullinformation/' + project_id + '/?format=json'},
  changePassword: 'change_password/?format=json',
  resetPassword: 'reset_password/?format=json',
  areas: 'area/?format=json',
  finishProjectComponent: (project_id, type, component_id) => {return 'project/' + project_id + '/finish/' + type + '/' + component_id + '/?format=json'},
  switchTraceability: (project_id) => {return 'project/' + project_id + '/switch_traceability/?format=json'},
  signatures: (project_id) => {return 'project/'+ project_id +'/get_signatures/?format=json'},
  signature: (project_id, user_id) => {return 'project/'+ project_id +'/user/' + user_id + '/get_signatures/?format=json'},
  signProject: (project_id) => {return 'project/'+ project_id +'/sign/?format=json'},
  projectComments: (project_id) => {return 'project/' + project_id + '/comments/?format=json'},
  startSignatureProcess: (project_id) => {return 'project/' + project_id + '/start_signature_process/?format=json'},
  companyData: (company_id) => {return 'company/' + company_id + '/data/?format=json'},
  changeStage: (company_id) => {return 'company/' + company_id + '/change_stage/?format=json'},
  currency: (company_id) => {return 'company/'+ company_id +'/?format=json'},
  chooseFilters: (company_id) => {return 'company/' + company_id + '/choose_filters/?format=json'},
  saveFilters: (company_id) => {return 'company/' + company_id + '/save_filters/?format=json'},
  approveProjects: (company_id) => {return 'company/' + company_id + '/approve_projects/?format=json'},
  company: (company_id) => {return 'company/' + company_id + '/?format=json'},
  companyIndexInfo: (company_id) => {return 'company/' + company_id + '/index_info?format=json'},
  projectPostulation: (hash) => {return 'company/project_postulation/' + hash + '/?format=json'},
  patchProjectPostulation: (project_id) => {return 'company/project_postulation/id/' + project_id + '/?format=json'},
  selectedProjects: (company_id) => {return 'company/' + company_id + '/selected_projects/?format=json'},
  economicSelection: (company_id, type) => {return 'company/' + company_id + '/economic_filters/' + type + '/?format=json'},
  getCurrentStage: (company_id) => {return 'company/' + company_id + '/current_stage/?format=json'},
  nextStage: (company_id) => {return 'company/' + company_id + '/next_stage/?format=json'},
  sendPostulationLinkEmail: (company_id) => {return 'company/' + company_id + '/send_postulation_link_email/?format=json'},
  portfolioDeadlines: (company_id) => {return 'company/' + company_id + '/portfolio_deadlines/?format=json'},
  indicator: (project_id) => {return 'project/' + project_id + '/indicator/?format=json'},
  rawIndicator: 'indicator',
  deleteProjectPostulation: (company_id, hash, project_id) => {return 'company/' + company_id + '/project_postulation/' + hash + '/project/' + project_id + '/?format=json'},
  getStages: 'stages/?format=json',
  getFilters: 'filter/?format=json',
  signS3: (project_id, file_name, file_type, upload_type) => {return 'project/' + project_id + '/s3_sign/?file_name=' + file_name + '&file_type=' + file_type + '&upload_type=' + upload_type + '&format=json'},
  dataSummary: (company_id) => {return 'company/' + company_id + '/statistics/data_summary&format=json'},
  projectsByState: (company_id) => {return 'company/' + company_id + '/statistics/projects_by_state&format=json'},
  dataByFilter: (company_id) => {return 'company/' + company_id + '/statistics/data_by_filter&format=json'},
  dataByProject: (company_id) => {return 'company/' + company_id + '/statistics/data_by_project&format=json'},
  updateProjectInfo: project_id => `project/${project_id}/edit&format=json`,
  innspiralStaff: 'innspiral_staff/?format=json',
  industries: 'industry/?format=json',
  companies: 'company/?format=json',
  createCompany: 'create_company/?format=json',
}



// WEBPACK FOOTER //
// ./src/config/ApiRoutes.js